import { Component, Input } from '@angular/core';
import { Breadcrumbs, NavigationOption } from './va-breadcrumbs';

@Component({
  selector: 'va-breadcrumbs',
  styleUrls: ['./va-breadcrumbs.component.scss'],
  templateUrl: './va-breadcrumbs.component.html',
  standalone: false,
})
export class VaBreadcrumbsComponent {
  @Input() breadcrumbs: Breadcrumbs[];
  NavigationOption_ROUTERLINK = NavigationOption.ROUTERLINK;
  NavigationOption_HREF = NavigationOption.HREF;
}
